import { api } from '../../api'

export const removeEventIemService = async (eventItemId: string) => {
  await api.delete(`/api/events/eventItems/${eventItemId}`)
}
